module.exports = __webpack_public_path__ + "static/img/22178B_5_6_C_20230302_fit.068537c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/22178B_5_6_C_20230302_fit.png
// module id = 6ILM
// module chunks = 0